<template>

  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="商会会员名称">
          <el-input placeholder="请输入商会会员名称" v-model="formInline.search">
          </el-input>
        </el-form-item>

        <el-form-item label="所属行业分类：" prop="categorya_id" :rules="[{ required: true, message: '请选择行业分类' }]">
      <el-select v-model="formInline.categorya_id" >
        <template v-for="cat in category">
          <el-option :value="cat.category_id" :key="cat.category_id" :label="cat.name"></el-option>
          <template v-if="cat.child !== undefined" v-for="two in cat.child">
            <el-option :value="two.category_id" :key="two.category_id" :label="two.name" style="padding-left: 30px;"></el-option>
            <template v-if="two.child !== undefined" v-for="three in two.child">
              <el-option :value="three.category_id" :key="three.category_id" :label="three.name" style="padding-left: 60px;"></el-option>
            </template>
          </template>
        </template>
      </el-select>
    </el-form-item>  

    <el-form-item >
      <el-button size="small" type="primary" icon="el-icon-search" @click="getData">查询</el-button>
 
       </el-form-item>

      </el-form>


    </div>

    <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick">添加商会会员</el-button>
    </div>


    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="name" label="商会会员名称"></el-table-column>

            <el-table-column prop="image" label="图片">
              <template slot-scope="scope">
                <img v-img-url="hasImages(scope.row.image_url)" alt="" width="60px" />
              </template>
            </el-table-column>
            <el-table-column prop="short_name" label="简称"></el-table-column>
            <el-table-column prop="categorya_name" label="行业分类"></el-table-column>
            <el-table-column prop="business" label="主营业务"></el-table-column>
            <el-table-column prop="intro" label="简介"></el-table-column>
            <el-table-column prop="linkman" label="联系人"></el-table-column>
            <el-table-column prop="phone" label="联系电话"></el-table-column>
            <el-table-column prop="grade.name" label="会员等级"></el-table-column>
            <el-table-column prop="is_coc" label="是否为诚优企业"></el-table-column>
            <el-table-column prop="address" label="地区"></el-table-column>
            <el-table-column prop="post" label="职位"></el-table-column>
            <el-table-column prop="belong_to" label="所属协会"></el-table-column>
            <el-table-column prop="time" label="入会时间"></el-table-column>
            <el-table-column prop="categorya.name" label="会员级别"></el-table-column>
            <el-table-column prop="status" label="状态">
              <template slot-scope="scope">
                <span v-if="scope.row.status == 0">未审核</span>
                <span v-if="scope.row.status == 1">审核通过</span>
                <span v-if="scope.row.status == 2">审核未通过</span>
              </template>
            </el-table-column>
            <el-table-column prop="reject_val" label="未通过原因"></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
                
                <el-button v-if="scope.row.status == 0" @click="passClick(scope.row)" type="text" size="small">审核</el-button>
                <el-button v-if="scope.row.status == 0" @click="nopassClick(scope.row)" type="text" size="small">审核不通过</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    
    <Add :open_add="open_add" v-if="open_add"   @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :coc_id="coc_id"  v-if="open_edit"   @close="closeEdit"></Edit>
  
  </div>
</template>

<script>
  import CocApi from '@/api/coc.js';
  import Add from './part/add.vue';
  import Edit from './part/edit.vue';
  export default {
    components: {
      Add,
      Edit
    },
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索表单对象*/
        form: {},
        formInline: {
          search:""
        },

        open_add:false,
        open_edit:false,
        coc_id:"",
        category:[]
      };
    },
    created() {

      /*获取列表*/
      this.getTableList();
      this.getCategory();
    },
    methods: {
      hasImages(e) {
        if (e) {
          return e;
        } else {
          return '';
        }
      },
       /*关闭添加*/
    closeAdd(e){
      this.open_add=false;
      this.getTableList();
    },
    
      /*获取行业分类*/
      getCategory() {
        // console.log(444);return 
        CocApi.getCategory('', true)
          .then(res => {
            this.category = res.data.category;
          })
          .catch(error => {

          });
      },
    closeEdit(e){
      this.open_edit=false;
      this.getTableList();
    },
    getData(){
      this.getTableList();
    },
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = this.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        self.loading = true;
        CocApi.list(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
          })
          .catch(error => {
          });
      },

      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },

      /*添加任务*/
      addClick() {
        this.open_add = true
      },

      /*编辑活动*/
      editClick(row) {
        this.coc_id = row.coc_id;
        this.open_edit = true
      },

      /*删除*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            CocApi.del(
              {
                coc_id: row.coc_id
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.getTableList();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      },
      passClick(item){//退款申请-通过审核
      var self = this;
      var Params = {
        coc_id:item.coc_id,
        status:1
      }
      CocApi.passCanel(Params, true)
        .then(data => {
          console.log(data)
          if(data.code == 1){
            self.$message({
                type: 'success',
                message: '审核成功'
            });
              self.getTableList();
              return false;
          }
        })
        .catch(error => {
          
         
        });

    },
    async nopassClick(item){//退款申请-不通过审核
      var self = this;
      const reject_val = await this.promptInput('请输入不通过的原图', '请输入2-4个汉字');

      var Params = {
        coc_id:item.coc_id,
        status:2,
        reject_val:reject_val
      }
      CocApi.passCanel(Params, true)
        .then(data => {
          if(data.code == 1){
            self.$message({
                type: 'success',
                message: '审核成功'
            });
              self.getTableList();
              return false;
          }
        })
        .catch(error => {});
    },
    async promptInput(message, validation) {
      try {
        const { value } = await this.$prompt(message, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputErrorMessage: validation,
        });
        return value.trim();
      } catch(e) {
        this.$message({
          type: 'info',
          message: '取消输入',
        });
      }
    },
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/coc/index.vue